<div class="main">
    <div class="device-config-header">
        <div class="header-info">
            <h4 class="mb-2">Device Configuration</h4>
            <p class="subtitle">
                You have {{ farms.length }} farm{{
                    farms.length !== 1 ? 's' : ''
                }}
                available
            </p>
        </div>
        <button (click)="editFarm()" class="btn-action-primary">
            Edit Farm
        </button>
    </div>

    <div class="device-config-content">
        <div class="farm-tabs">
            <button
                *ngFor="let farm of farms"
                class="farm-tab"
                [ngClass]="{'active-tab': farm.id === selectedFarmId}"
                (click)="selectFarm(farm.id)"
            >
                {{ farm.name }}
            </button>
        </div>

        <div class="farm-content" *ngFor="let farm of farms">
            <div *ngIf="farm.id === selectedFarmId">
                <div class="farmhouses-list">
                    <div
                        *ngFor="let house of farm.farmHouses"
                        class="farmhouse-card"
                    >
                        <div class="farmhouse-header">
                            <div class="farmhouse-title">
                                <h4>{{ house.name }}</h4>
                                <p class="farmhouse-dimensions">
                                    {{ house.length }}L x {{ house.width }}W
                                </p>
                            </div>
                        </div>

                        <div class="partitions-grid">
                            <div
                                *ngFor="
                                    let partition of house.farmHousePartitions
                                "
                                class="partition-card"
                                [ngClass]="{
                                    'partition-available':
                                        !partition.capacityStatus,
                                    'partition-busy': partition.capacityStatus
                                }"
                            >
                                <div class="partition-header">
                                    <div class="partition-info">
                                        <h5>{{ partition.name }}</h5>
                                        <p class="partition-length">
                                            Length: {{ partition.length }}m
                                        </p>
                                    </div>
                                    <button
                                        class="btn-config-sensor"
                                        pTooltip="Configure Sensors"
                                        tooltipPosition="top"
                                        (click)="
                                            openAddSensorPopup(
                                                farm.id,
                                                house.id,
                                                partition.id
                                            )
                                        "
                                    >
                                        <i class="fas fa-cog"></i>
                                    </button>
                                </div>

                                <div class="partition-details">
                                    <div class="detail-item">
                                        <label>Capacity:</label>
                                        <span>{{ partition.capacity }}</span>
                                    </div>
                                    <div class="detail-status">
                                        <i
                                            class="fas fa-circle status-indicator"
                                        ></i>
                                        <span>{{
                                            !partition.capacityStatus
                                                ? 'Available'
                                                : 'Busy'
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="farmhouse-footer">
                            <p class="partition-count">
                                <i class="fas fa-grip-horizontal"></i>
                                Total Partitions:
                                {{ house.farmHousePartitions.length }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog
    [(visible)]="displayfarm"
    modal="true"
    [style]="{width: '1200px'}"
    [closable]="false"
>
    <ng-template pTemplate="content">
        <app-farm (close)="onCloseFarmDialog()"></app-farm>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="displaySensorPopup"
    modal="true"
    [style]="{width: '600px', maxWidth: '90vw'}"
    (onHide)="closePopup()"
    [draggable]="false"
    [resizable]="false"
>
    <ng-template pTemplate="header">
        <div class="dialog-header">
            <h3>Farm Sensor Configuration</h3>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="sensor-dialog-content">
            <div
                class="existing-sensors-section"
                *ngIf="farmHouseSensorsList && farmHouseSensorsList.length > 0"
            >
                <h5 class="section-title">Existing Sensors</h5>
                <div class="sensors-table-wrapper">
                    <table class="sensors-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Device ID</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let sensor of farmHouseSensorsList;
                                    index as i
                                "
                            >
                                <td>{{ i + 1 }}</td>
                                <td>{{ sensor.sensorName }}</td>
                                <td>{{ sensor.deviceId }}</td>
                              
                                 <!-- TOGGLE BUTTON -->
                                <td>
                                    <label class="switch">
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="sensor.isEnabled"
                                            (change)="toggleSensor(sensor)"
                                        />
                                        <span class="slider"></span>
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div
                class="no-sensors-message"
                *ngIf="
                    !farmHouseSensorsList || farmHouseSensorsList.length === 0
                "
            >
                <i class="fas fa-info-circle"></i>
                <p>No sensors configured yet</p>
            </div>

            <div class="add-sensors-section">
                <h5 class="section-title">Add New Sensors</h5>
                <div class="sensors-selection">
                    <div
                        *ngFor="let sensor of sensors; let i = index"
                        class="sensor-dropdown-row"
                    >
                        <div class="sensor-dropdown-wrapper">
                            <p-dropdown
                                [options]="sensorsList"
                                [(ngModel)]="sensor.sensorId"
                                placeholder="Select Sensor"
                                optionLabel="name"
                                optionValue="id"
                                appendTo="body"
                                [ngModelOptions]="{standalone: true}"
                                [filter]="true"
                                filterBy="name"
                                [showClear]="true"
                            >
                            </p-dropdown>
                        </div>
                        <button
                            class="btn-remove-sensor"
                            (click)="removeSensor(i)"
                            *ngIf="sensors.length > 1"
                            title="Remove sensor"
                        >
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                <button class="btn-add-sensor" (click)="addSensor()">
                    <i class="fas fa-plus"></i> Add Another Sensor
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <button
                type="button"
                class="close-btn-secondary"
                (click)="closePopup()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn-action-primary"
                (click)="saveSensors()"
            >
                Save Sensors
            </button>
        </div>
    </ng-template>
</p-dialog>
